export default __webpack_public_path__ + "static/media/End Button.eb99d08d.png";